import React from "react";
import { Alert, Button, Container } from "@mui/material";
import { RefreshOutlined } from "@mui/icons-material";

/* Evita que un error de render deje la pantalla en blanco */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <Container className="my-5" maxWidth="sm">
        <Alert severity="error" sx={{ mb: 2 }}>
          No pudimos mostrar esta sección. El resto de la aplicación sigue funcionando.
        </Alert>
        <p style={{ color: "#666", fontSize: "14px" }}>{error.message}</p>
        <Button
          variant="contained"
          startIcon={<RefreshOutlined />}
          onClick={() => this.setState({ error: null })}
        >
          Reintentar
        </Button>
      </Container>
    );
  }
}

export default ErrorBoundary;
